import { flowMax, SimpleUnchangedProps } from 'ad-hok'
import { addEffectOnMount } from 'ad-hok-utils'
import { Action, Category } from 'shared/src/utils/analytics'

import { addBannerContext, Banner } from 'components/banners'
import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { APP_WAITLIST_URL, GO2APP_URL, SHOPPER_URL } from './urls'

export const mobileOpenDownloadAppBanner: SimpleUnchangedProps = flowMax(
  addBannerContext,
  addTranslationHelpers,
  addEffectOnMount(({ showBanner, t }) => () => {
    const iOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    if (!iOS) {
      return
    }
    if (window.location.pathname.match(/\/((referral\/.+))|\/grabTheApp$/)) {
      return
    }
    const baseUrl = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }`
    const urlParams = new URLSearchParams(window.location.search)

    let appUrl = window.location.href
    if (appUrl.indexOf(GO2APP_URL) !== -1) {
      appUrl = appUrl.replaceAll(baseUrl, SHOPPER_URL.replace(/\/$/, ''))
      appUrl = appUrl.replace(window.location.hash, '')
      appUrl = appUrl.replace(window.location.search, '')
      urlParams.append('go2AppStore', '1')
      appUrl += '?' + urlParams.toString()
      appUrl += window.location.hash
      window.location.href = appUrl
      return
    }
    if (urlParams.get('go2AppStore')) {
      window.location.href = APP_WAITLIST_URL
      return
    }
    appUrl = appUrl.replaceAll(baseUrl, GO2APP_URL.replace(/\/$/, ''))

    let bannerCfg = {
      textTranslationKey: 'banners.mobileOpenDownloadApp.appName',
      onCloseAnalyticsEvent: {
        options: {
          category: 'general' as Category,
          action: 'banner_open_download_in_app_close' as Action,
        },
      },
      link: {
        title: t('banners.mobileOpenDownloadApp.title'),
        navigateTo: appUrl,
        external: false,
        onClickAnalyticsEvent: {
          options: {
            category: 'general' as Category,
            action: 'banner_open_download_in_app_click' as Action,
          },
        },
      },
    } as Banner
    sessionStorage.setItem('bannerCount', '0')
    const intRef = setInterval(() => {
      const bannerCount = sessionStorage.getItem('bannerCount') || '0'
      if (parseInt(bannerCount) > 4) {
        showBanner(bannerCfg)
        clearInterval(intRef)
      }
    }, 1000)
  })
)
